// Shared helpers for comma-separated email fields (Contact email, Finance email).
// Kept in one place so the chip input and the Yup validation stay in sync.

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email) =>
  typeof email === 'string' && EMAIL_REGEX.test(email.trim());

// Turn a stored comma-separated string into a clean array of emails.
export const parseCommaEmails = (value) =>
  typeof value === 'string'
    ? value
        .split(',')
        .map((e) => e.trim())
        .filter(Boolean)
    : [];

// Join an array of emails back into the comma-separated string we persist.
export const formatCommaEmails = (emails) =>
  Array.isArray(emails) ? emails.join(',') : '';

// True when every non-empty entry in the string is a valid email.
export const areAllEmailsValid = (value) => {
  if (!value || value.trim() === '') return true;
  return parseCommaEmails(value).every(isValidEmail);
};
